import axios from "axios";
import router from "./router";
import { Message } from 'element-ui';

let http = axios.create({
  baseURL: "https://www.migezhihui.com/",
  timeout: 10000,
});

// 请求拦截器
http.interceptors.request.use(
  (config) => {
    config.headers.Authorization = 'Bearer '+ window.localStorage.getItem("token");
    return config;
  },
  (err) => {
    Message({
      message: "网络错误",
      type: "warning",
    });
    console.log(err,window.localStorage.getItem('client_id'));
  }
);

// 响应拦截器
http.interceptors.response.use(
  (Response) => {
    if (Response.data.code === 401) {
      setTimeout(()=>{
        router.push({
          path:'/login'
        });
      },1000)
      return Response.data;
    } else if (Response.data.code === 0) {
      Message({
        message: Response.data.msg,
        type: "error",
      });
      return Response.data;
    } else if (Response.data.code) {
      return Response.data;
    }
    console.log(Response)
  },
  (error) => {
    console.error(error, "error");
  }
);

// post请求
const post = (url, data) => http.post(url, data);
const get = (url, data) => http.get(url, {
  params:{...data}
});
const host = "www.migezhihui.com/";
const wssUrl = 'wss://'+host+'wss';
const baseURL = "https://www.migezhihui.com";
export default { post, get, baseURL,wssUrl };
